import { gsap } from 'gsap';

import type { FrameCallback, FrameSource } from '@/core/FrameSource';

/** Adapte le ticker GSAP au contrat `FrameSource` du moteur. */
export class GsapFrameSource implements FrameSource {
  subscribe(callback: FrameCallback): () => void {
    const listener = (time: number, deltaMs: number): void => {
      callback({ elapsed: time, delta: Math.min(deltaMs / 1000, 0.1) });
    };
    gsap.ticker.add(listener);
    return () => {
      gsap.ticker.remove(listener);
    };
  }
}
